import { OrgRoleIds, RoleIds } from "../models/Role.model";

/**
 * Map of organization role IDs to user-friendly display names
 */
const orgRoleDisplayNames: Record<OrgRoleIds, string> = {
  [OrgRoleIds.Owner]: "Owner",
  [OrgRoleIds.Admin]: "Admin",
  [OrgRoleIds.Maintainer]: "Maintainer",
  [OrgRoleIds.Member]: "Member",
  [OrgRoleIds.ViewOnly]: "View Only",
};

/**
 * Get the display name for an organization role ID
 * @param roleId - The role ID from the permission
 * @returns The user-friendly display name, or the roleId itself if not found
 */
export const getOrgRoleDisplayName = (
  roleId: OrgRoleIds,
): string | undefined => {
  return orgRoleDisplayNames[roleId];
};

/**
 * Get the display name for a role ID
 * @param roleId - The role ID from the permission
 * @returns The user-friendly display name, or the roleId itself if not found
 */
export const getRoleDisplayName = (
  roleId: RoleIds | undefined,
): string | undefined => {
  if (!roleId) return undefined;
  return orgRoleDisplayNames[roleId] ?? roleId;
};

export const isOrgAdminRole = (roleId: RoleIds | undefined): boolean => {
  return roleId === OrgRoleIds.Owner || roleId === OrgRoleIds.Admin;
};

export const isOrgAdminOrMaintainerRole = (
  roleId: RoleIds | undefined,
): boolean => {
  return isOrgAdminRole(roleId) || roleId === OrgRoleIds.Maintainer;
};
